import { Link, useNavigate } from "react-router-dom"
import { BsPencilSquare, BsFillTrashFill } from 'react-icons/bs';
import DeleteModal from "../../../components/modal/DeleteModal";
import { useEffect, useState } from "react";
import useListProject from "./useListProject";
import { Input } from "antd";
import Loading from "../../../components/loading/Loading";
import { SearchOutlined } from "@ant-design/icons";
import ActionButtonGradient from "../../../components/button/ActionButtonGradient";

const ListProject = () => {
    const navigate = useNavigate()
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [expandedYears, setExpandedYears] = useState({});
    const {
        phases,
        projects,
        getListPhase, 
        getListProject,
        page, 
        deleteProject,
        setFilterNameUser,
        limit, 
        filterName,
        searchInput,
        loadingPagestate
    } = useListProject()
    
    useEffect(() => {
        getListPhase()
        getListProject(page)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        getListProject(page)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [limit,  filterName])

    useEffect(() => {
        // Expand all years by default when projects load
        if (projects && projects.length > 0) {
            const years = [...new Set(projects.map(p => p.Year))];
            const expanded = {};
            years.forEach(year => expanded[year] = true);
            setExpandedYears(expanded);
        }
    }, [projects])

    const [deleteID, setDeleteID] = useState()
    const [projectName, setProjectName] = useState()

    const toggleYear = (year) => {
        setExpandedYears(prev => ({
            ...prev,
            [year]: !prev[year]
        }));
    }

    return(
        <div className="container-fluid justify-content-center" style={{ 
            maxWidth: '1200px', 
            margin: '0 auto',
            width: '100%',
        }}>
            <Loading state={loadingPagestate}/>
            
            {/* Phase Section */}
            <div style={{
                backgroundColor: '#ffffff',
                borderRadius: '12px',
                padding: '24px',
                marginBottom: '24px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                border: '1px solid #f0f0f0'
            }}>
                <div className="d-flex align-items-center justify-content-between mb-3">
                    <h5 style={{ 
                        margin: 0,
                        fontWeight: 600,
                        color: '#1a1a1a',
                        fontSize: '18px'
                    }}>
                        Phase
                    </h5>
                    { phases && phases.length>=0 ? 
                        <ActionButtonGradient
                            onClick={() => navigate("phase")}
                            variant="primary"
                            children={"Manage Phase"}
                        /> :
                        <ActionButtonGradient
                            onClick={() => navigate("phase")}
                            variant="success"
                            children={"Add Phase"}
                        />
                    }
                </div>
                
                <div className="table-responsive">
                    <table className="table align-items-center">
                        <thead>
                            <tr style={{ backgroundColor: '#f8f9fa' }}>
                                {
                                    phases && phases?.map((phase) => (
                                        <th scope="col" key={phase.Order} style={{ 
                                            fontWeight: 600, 
                                            color: '#495057', 
                                            padding: '12px',
                                            fontSize: '14px'
                                        }}>
                                            Phase {phase.Order}
                                        </th>
                                    ))
                                }
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                {
                                    phases && phases?.map((phase) => (
                                        <td key={phase.Order} style={{ 
                                            padding: '12px', 
                                            color: '#495057',
                                            fontSize: '14px'
                                        }}>
                                            {phase.Name}
                                        </td>
                                    ))
                                }
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Project Section */}
            <div style={{
                backgroundColor: '#ffffff',
                borderRadius: '12px',
                padding: '24px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                border: '1px solid #f0f0f0'
            }}>
                <div className="d-flex align-items-center justify-content-between mb-3">
                    <h5 style={{ 
                        margin: 0,
                        fontWeight: 600,
                        color: '#1a1a1a',
                        fontSize: '18px'
                    }}>
                        Project
                    </h5>
                    <div className="d-flex align-items-center gap-3">
                        <Input 
                            placeholder="Search by project name" 
                            allowClear 
                            value={searchInput}
                            onChange={setFilterNameUser}
                            style={{
                                width: '300px',
                                borderRadius: '8px',
                                border: '1px solid #dee2e6',
                                padding: '8px 12px',
                                fontSize: '16px'
                            }}
                            prefix={<SearchOutlined style={{ color: '#bfbfbf' }} />}
                        />
                        <ActionButtonGradient
                            onClick={() => navigate("project-form")}
                            variant="success"
                            children={"Create Project"}
                        />
                    </div>
                </div>
                
                {/* Group projects by year */}
                {
                    projects && (() => {
                        // Group projects by year
                        const groupedProjects = projects.reduce((acc, project) => {
                            const year = project.Year;
                            if (!acc[year]) {
                                acc[year] = [];
                            }
                            acc[year].push(project);
                            return acc;
                        }, {});

                        // Sort projects within each year by Name (alphabetically)
                        Object.keys(groupedProjects).forEach(year => {
                            groupedProjects[year].sort((a, b) => a.Name.localeCompare(b.Name));
                        });

                        // Sort years in descending order (2025, 2024, etc.)
                        const sortedYears = Object.keys(groupedProjects).sort((a, b) => b - a);

                        return sortedYears.map((year) => (
                            <div key={year} style={{ marginBottom: '24px' }}>
                                {/* Year Header - Clickable */}
                                <div
                                    onClick={() => toggleYear(year)}
                                    style={{
                                        margin: 0,
                                        marginBottom: '12px',
                                        fontWeight: 600,
                                        color: '#495057',
                                        fontSize: '18px',
                                        paddingBottom: '8px',
                                        borderBottom: '2px solid #e9ecef',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                        userSelect: 'none',
                                        transition: 'color 0.2s ease'
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.color = '#02B4CC';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.color = '#495057';
                                    }}
                                >
                                    <span style={{
                                        transform: expandedYears[year] ? 'rotate(90deg)' : 'rotate(0deg)',
                                        transition: 'transform 0.2s ease',
                                        fontSize: '12px'
                                    }}>▶</span>
                                    <span>{year}</span>
                                    <span style={{ 
                                        fontSize: '13px', 
                                        fontWeight: 400, 
                                        color: '#6c757d' 
                                    }}>({groupedProjects[year].length} project{groupedProjects[year].length !== 1 ? 's' : ''})</span>
                                </div>

                                {/* Projects for this year - Collapsible */}
                                {expandedYears[year] && (
                                    <div style={{ display: 'grid', gap: '12px' }}>
                                    {groupedProjects[year].map((project) => (
                                        <div 
                                            key={project.ID}
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                padding: '16px',
                                                backgroundColor: project.Active ? '#f0fdf4' : '#f8f9fa',
                                                borderRadius: '8px',
                                                border: project.Active ? '1px solid #86efac' : '1px solid #e9ecef',
                                                transition: 'all 0.2s ease',
                                            }}
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.borderColor = project.Active ? '#22c55e' : '#02B4CC';
                                                e.currentTarget.style.backgroundColor = project.Active ? '#dcfce7' : '#f8f9fa';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.borderColor = project.Active ? '#86efac' : '#e9ecef';
                                                e.currentTarget.style.backgroundColor = project.Active ? '#f0fdf4' : '#f8f9fa';
                                            }}
                                        >
                                            <div className="d-flex align-items-center">
                                                <div style={{
                                                    backgroundColor: project.Active ? '#22c55e' : '#6c757d',
                                                    color: 'white',
                                                    width: '50px',
                                                    height: '50px',
                                                    borderRadius: '8px',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    fontWeight: 'bold',
                                                    fontSize: '18px',
                                                    marginRight: '16px'
                                                }}>
                                                    {project.Name.substring(0, 2).toUpperCase()}
                                                </div>
                        
                                                <div>
                                                    <h5 style={{ 
                                                        margin: 0, 
                                                        marginBottom: '4px',
                                                        fontSize: '18px',
                                                        fontWeight: 600,
                                                        color: '#1a1a1a'
                                                    }}>
                                                        <Link 
                                                            to={`/project-list/project/${project.ID}/1`}
                                                            style={{ 
                                                                color: '#02B4CC',
                                                                textDecoration: 'none'
                                                            }}
                                                            onMouseEnter={(e) => {
                                                                e.target.style.textDecoration = 'underline';
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                e.target.style.textDecoration = 'none';
                                                            }}
                                                        >
                                                            {project.Name}
                                                        </Link>
                                                    </h5>
                                                    <span style={{
                                                        fontSize: '13px',
                                                        color: project.Active ? '#16a34a' : '#6c757d',
                                                        fontWeight: project.Active ? '600' : '400'
                                                    }}>
                                                        {project.Active === true? '● Active': '○ Not Active'}
                                                    </span>
                                                </div>
                                            </div>
                                            
                                            <div className="d-flex gap-2">
                                                <button 
                                                    onClick={() => navigate(`project-form/${project.ID}`)}
                                                    title="Edit project"
                                                    style={{
                                                        padding: '8px 12px',
                                                        borderRadius: '5px',
                                                        border: '1px solid #02B4CC',
                                                        backgroundColor: 'transparent',
                                                        color: '#02B4CC',
                                                        cursor: 'pointer',
                                                        fontSize: '14px',
                                                        fontWeight: '500',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '6px',
                                                        transition: 'all 0.2s ease'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.backgroundColor = '#02B4CC';
                                                        e.currentTarget.style.color = 'white';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.backgroundColor = 'transparent';
                                                        e.currentTarget.style.color = '#02B4CC';
                                                    }}
                                                >
                                                    <BsPencilSquare size={14}/>
                                                    Edit
                                                </button>
                                                <button 
                                                    onClick={() => {
                                                        handleShow()
                                                        setDeleteID(project.ID)
                                                        setProjectName(project.Name)
                                                    }}
                                                    title="Delete project"
                                                    style={{
                                                        padding: '8px 12px',
                                                        borderRadius: '5px',
                                                        border: '1px solid #dc3545',
                                                        backgroundColor: 'transparent',
                                                        color: '#dc3545',
                                                        cursor: 'pointer',
                                                        fontSize: '14px',
                                                        fontWeight: '500',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '6px',
                                                        transition: 'all 0.2s ease'
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.backgroundColor = '#dc3545';
                                                        e.currentTarget.style.color = 'white';
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.backgroundColor = 'transparent';
                                                        e.currentTarget.style.color = '#dc3545';
                                                    }}
                                                >
                                                    <BsFillTrashFill size={14}/>
                                                    Delete
                                                </button>
                                            </div>
                                        </div>
                                    ))}
                                    </div>
                                )}
                            </div>
                        ));
                    })()
                }
            </div>
            
            <DeleteModal show={show} handleClose={handleClose} handleOk={() => {
                handleClose()
                deleteProject(deleteID)
            }} title={projectName}/>
        </div>
    )
}

export default ListProject